<div class="container container_vh" fxLayoutAlign.gt-xs="center center">
  <div class="content" id="social-facebook" fxLayout.gt-xs="row wrap" fxLayout.lt-sm="column">
    <div class="card" *ngFor="let post of facebookDataSource">
      <div class="fb-post" *ngIf="post.visibility == 1" [attr.data-href]="post.permalink_url" data-width="350"
        data-show-text="true">
      </div>
    </div>
  </div>
</div>